import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
